<template>
  <div class="brands-icon" @scroll="handleScroll">
    <div class="search-brand-input">
      <BFormInput placeholder="szukaj" v-model="filter"/>
    </div>

    <v-bar wrapper="wrapper" vBar vBarInternal hBar hBarInternal>
      <div class="brands-icon-data">
        <div v-for="brand in filterList" class="brand-icon">
          <div class="content" @click="selected(brand)">
            <img :src="brand.logo" :alt="brand.name">
            <p v-if="brand.iphname">{{brand.iphname}}</p>
            <p v-else>{{brand.name}}</p>
            <div class="content-hover"></div>
          </div>
        </div>
      </div>
    </v-bar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VBar from "v-bar";

export default {
  components: {
    VBar
  },
  computed: {
    ...mapState({
      list: state => state.brands.list
    })
  },
  data() {
    return {
      filter: "",
      filterList: [],
      scrollPosition: 0
    };
  },
  watch: {
    filter: function() {
      this.filteringList();
    },
    list: function() {
      this.filteringList();
    }
  },
  methods: {
    filteringList() {
      this.filterList = this.list.filter(
        b =>
          b.name.toLowerCase().indexOf(this.filter.toLowerCase()) == 0 ||
          (b.iphname &&
            b.iphname.toLowerCase().indexOf(this.filter.toLowerCase()) == 0)
      );
    },
    selected(brand) {
      this.$store.dispatch("brands/selected", {brand:brand,top:true});
      this.$router.replace({ name: "searchPage" });
    },
    handleScroll(e) {
      var currentScrollPosition = e.srcElement.scrollTop;
      if (currentScrollPosition > this.scrollPosition) {
        console.log("Scrolling down");
      }
      this.scrollPosition = currentScrollPosition;
    }
  },
  beforeMount() {
    this.$store.dispatch("brands/requestData");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/brands/src/BrandsIcon.vue